import React from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { getLocalizedStrings } from '../../../misc';

const BasicWifiAp = ({ basicWifiAp }) => {
  const {
    quoteSummary: {
      products: { basicWifiAp: labelBasicWifiAp },
      table: { qty, oneTimeCharges, monthlyCharges, total }
    }
  } = getLocalizedStrings();

  const {
    amount: {
      value: amountValue,
      qty: amountQty,
      prices: { oneTime: amountOneTime, monthly: amountMonthly } = {}
    } = {},
    totalMonthly,
    totalOneTime
  } = basicWifiAp || {};

  return (
    <>
      {basicWifiAp && (
        <div style={{ overflowX: 'auto' }}>
          <Heading level="h3">{labelBasicWifiAp}</Heading>
          <br />
          <table>
            <thead>
              <tr>
                <th width="60%"></th>
                <th>{qty}</th>
                <th>{oneTimeCharges}</th>
                <th>{monthlyCharges}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {amountValue}
                </td>
                <td>{amountQty}</td>
                <td>{formatPrice(amountOneTime)}</td>
                <td>{formatPrice(amountMonthly)}</td>
              </tr>
              <tr>
                <td>{total}</td>
                <td></td>
                <td>{formatPrice(totalOneTime)}</td>
                <td>{formatPrice(totalMonthly)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

BasicWifiAp.defaultProps = {
  basicWifiAp: {}
};

BasicWifiAp.propTypes = {
  basicWifiAp: PropTypes.objectOf(PropTypes.any)
};

export default BasicWifiAp;
